import { Action } from '@ngrx/store';
import { Product } from '../../dto';

export enum SelectProductActionTypes {
  SET_PRODUCT = 'SET_PRODUCT',
  REMOVE_PRODUCT = 'REMOVE_PRODUCT',
}

export enum SelectType {
  CART,
  ADD, // 추가 관련 상태값
}

export class SelectProductPayload {
  product: Product;
  selectType: SelectType;
}

export class SetProduct implements Action {
  readonly type = SelectProductActionTypes.SET_PRODUCT;
  constructor(public payload: SelectProductPayload) {}
}

export class RemoveProduct implements Action {
  readonly type = SelectProductActionTypes.REMOVE_PRODUCT;
  constructor() {}
}

export type SelectProductActions = SetProduct | RemoveProduct;
